export default {
  path: '/pptAgent',
  name: 'pptAgent',
  meta: { title: 'PPT智能体' },
  children: [
    {
      path: '/pptAgent/:type',
      name: 'pptAgentIndex',
      component: () => import('@/views/pptAgent/index.vue'),
      meta: { title: 'PPT智能体', subTitle: '智能适配行业场景，让 PPT 创作更省心高效', key: 'pptAgent' },
    },
  ],
};
